<div
	class="col text-center"
	*ngIf="loading">
	<app-loader
		[dark]="true"
		[material]="false"></app-loader>
</div>
<div
	[hidden]="loading || gantt?.lines?.length === 0"
	id="chartdiv"
	style="width: 100%; height: 800px"></div>
<div
	*ngIf="gantt?.lines?.length === 0"
	class="text-center">
	{{'labels.no-data-found' | translate}}
</div>

<div class="row mt-2">
	<div *ngFor="let line of gantt?.legend; index as i">
		<div
			class="box mx-2"
			[ngStyle]="{'background-color': colors[i].hex}">
		</div>
		{{line?.label}}
	</div>
</div>
